/**
 * Various generic functions.
 */

import * as r from 'ramda';

export const mapCat = r.curryN(2, function (fn, list) {
    return r.reduce(r.concat, [], r.map(fn, list));
});
